/* eslint-disable no-nested-ternary */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-empty */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-var */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable object-shorthand */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-const */
/* eslint-disable arrow-body-style */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-else-return */
/* eslint-disable prefer-template */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
// import './App.css';
// eslint-disable-next-line prefer-destructuring

import React, { useState, useMemo, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { connect, useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line import/no-extraneous-dependencies
import "react-big-calendar/lib/css/react-big-calendar.css";
import Grid from "@mui/material/Grid";
import axios from "axios";
import clsx from "clsx";
import {
  MESSAGE_TYPE,
} from "../../constants";
import styles from "./Calendar.module.css";
import { Button} from "../../atomicComponents";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { setLogin } from '../../redux/features/auth/actions';
import * as dates from "./dates";
import apiService from "../../apis/apiService";


const ColoredDateCellWrapper = ({ children }) =>
  React.cloneElement(React.Children.only(children), {
    style: {
      backgroundColor: "lightblue",
    },
  });

function Cal({ auth }) {
  const { userRole, personNumber } = auth;
  const baseUrl = useSelector((state) => state.counter.baseUrl);
  const [selectedBookTimeItems, setSelectedBookTimeItems] = useState([]);
  const [selectedViewBookingItems, setSelectedViewBookingItems] = useState([]);
  const [timeBook, setTimeBook] = useState([]);

  const [actionDeleteBtn, setDeleteBtn] = useState(false);
  const [actionDeleteBtn2, setDeleteBtn2] = useState(false);
  const [formattedEvents, setFormattedEvents] = useState([]);
  const [currentDate1, setCurrentDate1] = useState(new Date());
  const [validDateRange, setValidDateRange] = useState([]);
  const [isCallCalendarAPI, setIsCallCalendarAPI] = useState(false);

  const dispatchNew= useDispatch();

  const history = useHistory();

  const CustomDayHeader = ({ children, ...props }) => {
    return (
      <div className="rbc-day-content">
        <h3 className={styles.headerSet}>{props.label}</h3>
      </div>
    );
  };

  const { showPopup } = usePopupManager();

  const handleSelectSlotCheck = (e, slotInfo, label, actionFlag) => {
    if (e.target.checked) {
      if (actionFlag == "Add") {
        const obj = Object.assign(slotInfo, {
          booked: 8,
          Action: "Book Time",
          isSelected: "Yes",
        });
        setTimeBook((prevData) => [...prevData, obj]);
      } else {
        let updatedState = [...timeBook];
        let newOBJ = updatedState.find((elemnt) => {
          const dateParts = elemnt?.MusterDate?.split("-");
          const firstDateElement = dateParts[0];
          return firstDateElement == label;
        });
        let indexs = updatedState.findIndex((elemnt) => {
          const dateParts = elemnt?.MusterDate?.split("-");
          const firstDateElement = dateParts[0];
          return firstDateElement == label;
        });
        newOBJ.isSelected = "Yes";
        updatedState.splice(indexs, 1, newOBJ);
        setTimeBook(updatedState);
      }
    } else {
      let updatedState = [...timeBook];
      let newOBJ = updatedState.find((elemnt) => {
        const dateParts = elemnt?.MusterDate?.split("-");
        const firstDateElement = dateParts[0];
        return firstDateElement == label;
      });
      let indexs = updatedState.findIndex((elemnt) => {
        const dateParts = elemnt?.MusterDate?.split("-");
        const firstDateElement = dateParts[0];
        return firstDateElement == label;
      });
      newOBJ.isSelected = "No";
      setTimeBook(updatedState);
    }
  };

  const checkBooking = (label) => {
    var check;

    if (timeBook.length >= 1) {
      check = timeBook.find((elemnt) => {
        const dateParts = elemnt?.MusterDate?.split("-");
        const propDateMonth = currentDate1.toISOString().split("T")[0];
        const formattedDate = moment(propDateMonth).format("DD-MM-YYYY");
        const month = formattedDate.split("-");
        const firstDateElement = dateParts[0];
        const dateMonth = dateParts[1];
        return firstDateElement == label && dateMonth == month[1];
      });

      return check;
    } else {
      return undefined;
    }
  };
  const setBtn = () => {
    const checkList = [...timeBook];
    const selectedIteam = checkList.filter(
      (element) => {
        return (
          (element.Action === "Book Time" && element.isSelected === "Yes") ||
          (element.Action === "View Booking" && element.isSelected === "Yes")
        );
      }
    );
    setSelectedViewBookingItems(selectedIteam);
    if (selectedIteam.length >= 1) {
      setDeleteBtn(false);
      return selectedIteam.length;
    } else {
      setDeleteBtn(true);
      return selectedIteam.length;
    }
  };
  const setBtn2 = () => {
    const checkList = [...timeBook];
    const selectedIteam = checkList.filter(
      (element) => {
        return (
          (element.Action === "Book Time" && element.isSelected === "Yes") ||
          (element.Action === "View Booking" && element.isSelected === "Yes")
        );
      }
    );
    setSelectedBookTimeItems(selectedIteam);
    if (selectedIteam.length >= 1) {
      setDeleteBtn2(false);
      return selectedIteam.length;
    } else {
      setDeleteBtn2(true);
      return selectedIteam.length;
    }
  };

  const handleTimeBooking = () => {
    const selectedDates1 = selectedBookTimeItems?.map((item) => {
      const yearFirstFormat = moment(item.MusterDate, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      return yearFirstFormat;
    });
  
    let fromDateMoment
    let toDateMoment
    let diffInDays
  
    if (selectedDates1.length > 1) {
      // Convert each date to a Moment.js object and filter out invalid ones
      const validDates = selectedDates1
        .map((date) => moment(date))
        .filter((momentObj) => momentObj.isValid());
      if (validDates.length > 1) {
        const minDate = moment.min(validDates);
        const maxDate = moment.max(validDates);
        fromDateMoment = minDate;
        toDateMoment = maxDate;
        diffInDays = maxDate.diff(minDate, "days") + 1;
      }
    } else {
      // If only one date is selected
      fromDateMoment = moment(selectedDates1[0]);
      toDateMoment = fromDateMoment;
      diffInDays = 1;
    }
  
    if (diffInDays > 10) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: `You can choose a period of a maximum of 10 Days in a batch`,
      });
    } else {
      let flag = setBtn2();
      if (flag >= 1) {
        history.push({
          pathname: "/erc-batch-time-booking",
          state: { selectedDates1 },
        });
      }
    }
  };
  const handleDeleteBooking = () => {
    const selectedDates1 = selectedViewBookingItems?.map((item) => {
      const yearFirstFormat = moment(item.MusterDate, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      return yearFirstFormat;
    });
    let flag = setBtn();
    if (flag >= 1) {
      history.push({
        pathname: "/booking-details-individual",
        state: { selectedDates1 },
      });
    } else {
      alert(flag);
    }
  };

  const getCheckValidDate = async() => {
    let data={}
    try {
      const response = await apiService.handleCheckValidDate(data,dispatchNew)
      setValidDateRange(response?.data);
        setIsCallCalendarAPI(true);
    }catch(error){
      dispatchNew(setLogin({...auth, recentStatus: error?.response?.status}))
    };
     
  };
  const getCalendarData = async(firstDayOfMonth, lastDayOfMonth) => {
    /* From and to dates are fetched from getCheckValidDate 
    API's response. */

    const body = {
      emp_id: personNumber,
      from_date:
        firstDayOfMonth === undefined || ""
          ? validDateRange[0][0]
          : firstDayOfMonth,
      to_date:
        lastDayOfMonth === undefined || ""
          ? validDateRange[0][1]
          : lastDayOfMonth,
    };
 
    try {
      const response = await apiService.getCalendarData(body,dispatchNew)   
      const events = response?.data?.map((item) => {
        const { MusterDate, Action } = item;
        const dateParts = MusterDate?.split("-"); // Assuming the date format is "DD-MM-YYYY"
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        const musterDate = new Date(formattedDate);
        return {
          title: Action,
          start: musterDate,
          end: musterDate,
        };
      });
      setFormattedEvents(events);
      setTimeBook(response.data);
    } catch (error) {
       dispatchNew(setLogin({...auth, recentStatus: error?.response?.status}))
    }
      
  };

  const isCurrentMonth = moment(currentDate1).isSame(new Date(), "month");
  const dayOfTheMonth = currentDate1.getDate();

  useEffect(() => {
    setBtn();
    setBtn2();
  }, [
    timeBook,
    actionDeleteBtn,
    actionDeleteBtn2,
  
  ]);

  useEffect(()=>{
    getCheckValidDate();
  },[
    isCurrentMonth,
   currentDate1,
  ])

  useEffect(() => {
    if (isCallCalendarAPI) {
      getCalendarData();
    }
  }, [isCallCalendarAPI]);

  const handleNavigate = (newDate) => {
    const isOtherMonth = currentDate1.getMonth() === newDate.getMonth();
    // Get the first day of the current month
    const firstDayOfMonth = new Date(
      newDate.getFullYear(),
      newDate.getMonth(),
      1
    );
    // Get the last day of the current month
    const lastDayOfMonth = new Date(
      newDate.getFullYear(),
      newDate.getMonth() + 1,
      0
    );
    // Convert the dates to desired formats
    const formattedFirstDay = `${firstDayOfMonth.getFullYear()}-${(
      firstDayOfMonth.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${firstDayOfMonth
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    const formattedLastDay = `${lastDayOfMonth.getFullYear()}-${(
      lastDayOfMonth.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${lastDayOfMonth
      .getDate()
      .toString()
      .padStart(2, "0")}`;

    if (!isOtherMonth) {
      getCalendarData(formattedFirstDay, formattedLastDay);
    }
    setCurrentDate1(newDate);
  };

  const CustomDay = ({ children, date, ...props }) => {
    let isInRangeFlag = false;
    if (validDateRange.length > 0) {
      const startDate = new Date(validDateRange[0][0]);
      const endDate = new Date(validDateRange[0][1]);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      const inputDate = new Date(date);
      inputDate.setHours(0, 0, 0, 0);
      isInRangeFlag = inputDate >= startDate && inputDate <= endDate;
    }

    if (props.isOffRange === true) {
      return (
        <div>
          <div>
            <p className={styles.calendar}>{props.label}</p>
          </div>
        </div>
      );
    } else {
      let flag = checkBooking(props.label);
      if (flag === undefined) {
        return (
          <div
            style={{
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              marginTop: "11px",
              marginLeft: "8px",
              fontSize: "8px",
              fontWeight: "bolder",
              color: "black",
            }}
          >
            <div>
              <div className={clsx(styles.calendar)}>
              
                {props.label}
              
              </div>
            </div>
          </div>
        );
      } else if (flag.Action == "No Swiping") {
        return (
          <div>
            <div>
              <div className={clsx(styles.calendar, styles.bgColoroffDay)}>
              
                {props.label}
              
              </div>
            </div>
          </div>
        );
      } else {
        let stylesCalendar =
          flag.Action == "Book Time"
            ? styles.bgColorUnBook
            : styles.bgColorBook;
        return (
          <div>
            <div>
              <div className={clsx(styles.calendar, stylesCalendar)}>
                {props.label}
                {/* eslint-disable-next-line no-nested-ternary */}
                {dayOfTheMonth > 5 && isCurrentMonth ? (
                  <input
                    type="checkbox"
                    checked={flag.isSelected == "Yes"}
                    onChange={(e) =>
                      handleSelectSlotCheck(e, props, props.label, "update")
                    }
                  />
                ) : isCurrentMonth ? (
                  <input
                    type="checkbox"
                    checked={flag.isSelected == "Yes"}
                    onChange={(e) =>
                      handleSelectSlotCheck(e, props, props.label, "update")
                    }
                  />
                ) : null}
                {/* eslint-disable-next-line no-nested-ternary */}
                {dayOfTheMonth > 5 ? null : !isCurrentMonth && isInRangeFlag ? (
                  <input
                    type="checkbox"
                    checked={flag.isSelected == "Yes"}
                    onChange={(e) =>
                      handleSelectSlotCheck(e, props, props.label, "update")
                    }
                  />
                ) : null}
                {dayOfTheMonth < 5 &&
                !isCurrentMonth &&
                flag.Action == "Book Time" &&
                isInRangeFlag ? (
                  <input
                    type="checkbox"
                    checked={flag.isSelected == "Yes"}
                    onChange={(e) =>
                      handleSelectSlotCheck(e, props, props.label, "update")
                    }
                  />
                ) : null}
                {/* condition change  checked */}
              </div>
            </div>
          </div>
        );
      }
    }
  };

  const { components, defaultDate, max, views } = useMemo(
    () => ({
      components: {
        timeSlotWrapper: ColoredDateCellWrapper,
        month: {
          header: CustomDayHeader,
          dateHeader: CustomDay,
        },
      },
      defaultDate: new Date(),
      max: dates.add(dates.endOf(new Date(2023, 1, 1), "day"), -1, "hours"),

      views: ["month"],
    }),
    [timeBook]
  );

  const localizer = momentLocalizer(moment);

  const handleSelectSlot = (slotInfo) => {
    const startDate = new Date(slotInfo.start.getFullYear(), slotInfo.start.getMonth(), slotInfo.start.getDate());
  const endDate = new Date(slotInfo.end.getFullYear(), slotInfo.end.getMonth(), slotInfo.end.getDate());
    const newEvent = {
      title: "booked",
      start: startDate,
      end: endDate,
      backgroundColor: "#F17C7C",
      allDay: true,
    };
    setFormattedEvents((prevData) => [...prevData, newEvent]);
  };

  const getSlotProps = (date) => {
    // Check if the date is booked
    const isBooked = formattedEvents.some((eventd) =>
      moment(date).isBetween(
        moment(eventd.start),
        moment(eventd.end),
        null,
        "[]"
      )
    );

    // Set the background color for booked slots
    const backgroundColor = isBooked ? "#F17C7C" : "";
    return {
      style: {
        backgroundColor,
      },
    };
  };

  const renderStatic = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={3}
        columns={12}
        style={{ justifyContent: "center"}}
      >
        <Grid item md={12} lg={12} sm={12} className={styles.cal_container}>
          <div>
            <Calendar
              className={styles.maninDiv}
              components={components}
              defaultDate={defaultDate}
              startAccessor="start"
              endAccessor="end"
              onSelectSlot={handleSelectSlot}
              localizer={localizer}
              showMultiDayTimes
              step={60}
              views={views}
              slotPropGetter={getSlotProps}
              onNavigate={handleNavigate}
            />
          </div>
          <Grid
            container
            style={{
              marginTop: "10px",
              justifyContent: "center",
            }}
            columns={12}
            className={styles.myGrid}
          >
            <Grid item md={12} lg={12}>
              <div className={styles.rowDiv}>
                <div className={styles.formDiv}>
                  <div
                    className={styles.circle}
                    style={{ backgroundColor: "rgba(130, 193, 167)" }}
                  ></div>
                  <div className={styles.lableMaster}>
                    <span className={styles.title2}>Booked Hrs </span>
                  </div>
                </div>
                <div className={styles.formDiv}>
                  <div
                    className={styles.circle}
                    style={{ backgroundColor: "#FFA222" }}
                  ></div>
                  <div className={styles.lableMaster}>
                    <span className={styles.title2}>Un-booked Hrs </span>
                  </div>
                </div>
                <div className={styles.formDivSwipe}>
                  <div
                    className={styles.circle}
                    style={{ backgroundColor: "#999999" }}
                  ></div>
                  <div className={styles.lableMaster}>
                    <span className={styles.title2}>
                      Holiday/Weekly Off/No Swipe
                    </span>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            style={{
              marginTop: "15px",
              justifyContent: "center",
              marginBottom: "30px",
            }}
            columns={12}
            className={styles.myGrid}
          >
            <Grid item md={7} lg={7}>
              <div className={styles.rowDiv1}>
                <div className={styles.formDiv}>
                  <Button
                    className={clsx(
                      styles.actionButton,
                      styles.primaryActionButton
                    )}
                    variant="primary"
                    onClick={handleTimeBooking}
                    disabled={actionDeleteBtn2}
                    data-testid="confirm-action"
                    style={{ marginRight: "5px" }}
                  >
                    Register Time
                  </Button>

                  <Button
                    className={clsx(styles.actionButton, styles.resetButton)}
                    variant="primary"
                    onClick={handleDeleteBooking}
                    style={{ marginRight: "5px" }}
                    disabled={actionDeleteBtn}
                  >
                    Delete Booking
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div
      className={clsx(
        styles.scrollContainer,
        styles.scrollBar,
        styles.formContainer
      )}
    >
      {renderStatic()}
    </div>
  );
}
const mapStateToProps = (state) => ({
  auth: state.auth,
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({});
Cal.propTypes = {};
export default connect(mapStateToProps, mapDispatchToProps)(Cal);
